module.exports = __webpack_public_path__ + "img/otherNews.ce05d337.svg";